import React from "react";

import "./Hero.css";

const Hero: React.FC = () => {

  return (
    <div className="HeroContainer" id="HeroContainer">
      <div className="HeroTitle" id="HeroTitle">
        On Mane
      </div>
    </div>
  );
}
export default Hero